var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgHistoryIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5234 0C16.0464 0 20.5234 4.477 20.5234 10C20.5234 15.523 16.0464 20 10.5234 20C5.00044 20 0.523438 15.523 0.523438 10H2.52344C2.52344 14.418 6.10544 18 10.5234 18C14.9414 18 18.5234 14.418 18.5234 10C18.5234 5.582 14.9414 2 10.5234 2C8.05944 2 5.85544 3.114 4.38844 4.865L6.52344 7H0.523438V1L2.97044 3.446C4.80344 1.336 7.50744 0 10.5234 0ZM11.5234 5V9.585L14.7664 12.828L13.3514 14.243L9.52344 10.413V5H11.5234Z",
    fill: "#26ABE1"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHistoryIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/historyIcon.0c92b68b.svg";
export { ForwardRef as ReactComponent };